import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import styles from './ApprovalContent.module.css';

const EmailConfirm = (props) => {
	const recipients = props.recipients?.length >= 0 ? props.recipients.join(",") : "";
	const [emails, setEmails] = useState(recipients);

	const validateEmail = (email) => {
		const re = /\S+@\S+\.\S+/;
		return re.test(email);
	};

	function proceed(str) {
		if (emails === "") {
			alert("Please enter email address");
			return;
		} else {
			const emailArray = emails.split(",");
			const invalidEmail = emailArray.filter((email) => {
				return !email.includes("@") || !validateEmail(email);
			});
			if (invalidEmail.length > 0) {
				alert("Please enter valid email address");
				return;
			}

			if (str === "send") {
				props.setNewRecipients(emails);
				props.closeForm();
			} else if (str === "saveSend") {
				props.setNewRecipients(emails);
				props.saveNewRecipients(true);
				props.closeForm();
			} else {
				alert("Invalid action");
				return;
			}
		}
	}

	return (
		<div className={`form-contents ${styles.emailConfirm}`}>
			<Row>
				<Col sm="11">
					<h5>Invoices and Reports would be sent to these recipients</h5>
					<p>Click Confirm to send. It would Cc you as well.</p>
					<p>Add: split addresses by <span style={{ textDecoration: "underline 1px black" }}>comma</span> (,)</p>
					<p>Remove: backspace words including <span style={{ textDecoration: "underline 1px black" }}>comma</span> (,)</p>
				</Col>
				<Col sm="1">
					<span
						onClick={() => props.closeForm()}
						style={{ float: "right", cursor: "pointer" }}
						className="glyphicon glyphicon-remove close-approval"
					></span>
				</Col>
			</Row>

			<div>
				<div className={styles.vatInvoiceForm}>
					<Row >
						<input type="text" value={emails} onChange={(e) => setEmails(e.target.value)} style={{ width: "100%", height: "3em" }} placeholder="abc@greenyellow.com,xyz@greenyellow.com" />
					</Row>
				</div>
				<div className="btn-container">
					<Row>
						<Col md="4">
							<button
								className="btn btn-primary btn-generate btn-approval"
								title="Confirm"
								onClick={() => proceed("saveSend")}
							>
								<span>Save & Confirm</span>
							</button>
						</Col>
						<Col md="4">
							<button
								className="btn btn-primary btn-generate btn-approval"
								title="Confirm"
								onClick={() => proceed("send")}
							>
								<span>Confirm</span>
							</button>
						</Col>
						<Col md="4">
							<button
								className="btn btn-primary btn-generate btn-approval"
								title="Confirm"
								onClick={() => props.closeForm()}
							>
								<span>Cancel</span>
							</button>
						</Col>
					</Row>
				</div>
			</div>
		</div>
	);
};

export default EmailConfirm;
